import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    id: $data.id,
    class: "dt-element__wrapper dt-element__map"
  }, " карта ", 8 /* PROPS */, _hoisted_1))
}